import React from 'react';
import classnames from 'classnames';

import css from './Link.module.scss';

const Link = (props) => {
  const {
    className,
    children,
    onClick,
  } = props;

  const classes = classnames(css.root, className);

  return (
    <a
      className={classes}
      onClick={onClick}
    >
      {children}
    </a>
  );
};

export default Link;
